import { blockPlayerInstance, calculateDuration, calculateDurationMs } from './blockPlayer.js';
import * as Tone from 'tone';
import { threeJSBand } from "./threejsBand";
import { getGamingMode } from "./game";

// Константы для notePlayer
const NOTE_PLAYER_CONFIG = {
    NOTE_TRAVEL_TIME_SECONDS: 4.0,
    DEFAULT_NOTE_DURATION: "4n",
    DELAY_MS: 4000
};

class NotePlayer {
    constructor() {
        this.sampler = blockPlayerInstance.sampler;
    }

    /**
     * Проигрывает ноту/аккорд и создает соответствующие визуальные ноты на сцене
     * @param {Object|Object[]} noteData - нота или массив нот (аккорд)
     * @param {number|null} duration - длительность звучания в секундах (опционально)
     */
    playNote(noteData, duration = null) {
        if (!noteData) return;

        // Отбрасываем паузы и некорректные ноты, чтобы Sampler не падал
        const rawNotes = Array.isArray(noteData) ? noteData : [noteData];
        const notes = rawNotes.filter(n => n && n.noteName && n.noteName !== '-Infinity');
        if (notes.length === 0) return;

        const { notesToPlay, noteDuration } = this.parseNoteData(notes, duration);
        if (notesToPlay.length === 0) return;

        this.createMovingNotes(notes);
        this.scheduleNotePlayback(notesToPlay, noteDuration, notes);
    }

    parseNoteData(noteData, duration) {
        let notesToPlay = [];
        let noteDuration = NOTE_PLAYER_CONFIG.DEFAULT_NOTE_DURATION;

        if (Array.isArray(noteData)) {
            notesToPlay = noteData.map(note => note.noteName);
            if (noteData.length > 0) {
                noteDuration = calculateDuration(noteData[0]);
                if (!duration) {
                    duration = calculateDurationMs(noteData[0]) / 1000;
                }
            }
        } else {
            notesToPlay = [noteData.noteName];
            noteDuration = calculateDuration(noteData);
            if (!duration) {
                duration = calculateDurationMs(noteData) / 1000;
            }
        }

        return { notesToPlay, noteDuration };
    }

    createMovingNotes(notes) {
        const currentTime = Tone.now();
        const targetTime = currentTime + NOTE_PLAYER_CONFIG.NOTE_TRAVEL_TIME_SECONDS;

        notes.forEach((note, index) => {
            if (threeJSBand) {
                // Ноты добавляются, hammer эффект создастся позже через updateHammerEffects
                threeJSBand.addMovingNote(note, currentTime, targetTime, true, null);
            }
        });
        
        // После добавления всех нот обновляем hammer эффекты
        if (threeJSBand) {
            threeJSBand.updateHammerEffects();
        }
    }

    scheduleNotePlayback(notesToPlay, noteDuration, notes) {
        setTimeout(() => {
            if (notesToPlay.length > 0) {
                const now = Tone.now();
                this.sampler.triggerAttackRelease(notesToPlay, noteDuration, now);

                if (!getGamingMode()) {
                    this.markNotesAsHit(notes);
                }
            }
        }, NOTE_PLAYER_CONFIG.DELAY_MS);
    }

    markNotesAsHit(notes) {
        notes.forEach(note => {
            if (threeJSBand) {
                threeJSBand.markNoteAsHit(note.string, note.fret);
            }
        });
    }
}

export const notePlayer = new NotePlayer();